import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import LearnMore from "../../../../components/learnMore/learnMore";
import { useDispatch, useSelector } from "react-redux";
import { Charts } from "../views";
import { FETCH_CURRENT_USER } from "../common/saga";

const MODULE_HEIGHT = 550;

export const FirstVisitConversions = (props) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.firstVisitConversions);
  const [filtersDirtySt2, setFiltersDirtySt2] = useState(false);

  useEffect(() => {
    fetchInitialData();
  }, []);

  function fetchInitialData() {
    dispatch({
      type: FETCH_CURRENT_USER + props.moduleName,
      payload: {
        currentUser: { ...props.currentUser },
        numberOfMonths: props.numberOfMonths,
        chartType: props.moduleName
      }
    });

    setFiltersDirtySt2(false);
  }

  return (
    <>
      <Charts
        sectionProps={{
          title: "First Visit Conversions",
          learnMore: <LearnMore {...props.learnMore} html />,
          customClass: `instructorperformanceWidget ${isLoading ? "" : "active"}`,
          height: MODULE_HEIGHT,
          isLoading: isLoading
        }}
        currentUser={props.currentUser}
        filtersDirtySt={filtersDirtySt2}
        fetchInitialData={fetchInitialData}
        isLoading={isLoading}
        moduleName={props.moduleName}
        notifications={props.notifications}
      />
    </>
  );
};

FirstVisitConversions.propTypes = {
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  learnMore: PropTypes.objectOf(PropTypes.string),
  numberOfMonths: PropTypes.number,
  moduleName: PropTypes.string,
  notifications: PropTypes.object
};
